import { useBCMSModal, useModel } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "../../index";
import "./styles.css";
import "./mobile.css";


/**
 * @function TransactionInquiryModal
 * @param {FUNCTION} onClick - Allows us to set an event handler on click to the primary modal button. 
 * @exported true
 * @returns {React.Component}
 * @description 
 * @example
 * <TransactionInquiryModal />
 */

export default function TransactionInquiryModal(props) {
  const { branding } = useModel();
  const { close } = useBCMSModal();
  const options = branding.options;
   let inquiryLabel = options.transaction_inquiry_label_abi22 ?? "Transaction Inquiry";
const transaction = props?.data?.view;

  const onClick = evt => {
    close("TransactionInquiryModal");
    const onSendClick = props?.data?.onSendClick;
    if(onSendClick) {
      onSendClick(transaction.id)(evt);
    }
  }

  return (
    <CustomModal title={inquiryLabel} id="TransactionInquiryModal" className="transaction-inquiry-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <FormContainer className="transaction-inquiry-form">
          <FormRowView text="Account">
            <p>{transaction.account.name} - {transaction.account.number}</p>
          </FormRowView>
          <FormRowView text="Transaction Type">
            <p>Dispute {transaction.amount.format()} charged on {transaction.date.format("m/d/Y")} for {transaction.description} ({transaction.status})</p>
          </FormRowView>
          <FormRowView className="message-form-row" text="Message">
            <textarea></textarea>
          </FormRowView>
          <FormRowView>
            <UICheckbox label="Send me a notification when there is a response to this message" />
          </FormRowView>
        </FormContainer>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
        <ModalCloseButton id="TransactionInquiryModal" />
        <ModalPrimaryButton text="Send" onClick={ onClick } />
      </CustomModalFooter>
    </CustomModal>
  )
}
